import { useEffect, useState } from "react";
import axios from "axios";
import { Heart, Play, Share2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";
import { AuthModal } from "@/components/auth/AuthModal";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export default function SpecialGameActions({ event, onPlay, disabled = false }) {
  const { user } = useAuth();
  const [liked, setLiked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [ready, setReady] = useState(false);
  const [showAuth, setShowAuth] = useState(false);
  const [loadAttempt, setLoadAttempt] = useState(0);
  const userId = user?.id;
  const headers = () => ({ Authorization: `Bearer ${localStorage.getItem("auth_token")}` });
  useEffect(() => {
    let active = true;
    setLiked(false);
    setReady(false);
    if (userId) axios.get(`${API}/events/${event.id}/like`, { headers: headers() })
      .then(({ data }) => { if (active) { setLiked(data.liked); setReady(true); } })
      .catch(() => { if (active) setReady(false); });
    return () => { active = false; };
  }, [event.id, loadAttempt, userId]);
  const toggleLike = async () => {
    if (!user) { setShowAuth(true); return; }
    if (!ready) { setLoadAttempt((value) => value + 1); toast.info("Carregando sua curtida. Tente novamente em instantes."); return; }
    setBusy(true);
    try {
      const { data } = await axios({ method: liked ? "delete" : "put", url: `${API}/events/${event.id}/like`, headers: headers() });
      setLiked(data.liked);
    } catch { toast.error("Não foi possível atualizar sua curtida. Tente novamente."); }
    finally { setBusy(false); }
  };
  const share = async () => {
    const url = new URL(`/jogos?specialGame=${encodeURIComponent(event.id)}`, process.env.REACT_APP_BACKEND_URL || window.location.origin).href;
    try {
      if (navigator.share) { await navigator.share({ title: event.title, url }); return; }
      await navigator.clipboard.writeText(url);
      toast.success("Link do jogo copiado!");
    } catch (error) {
      if (error.name === "AbortError") return;
      try { await navigator.clipboard.writeText(url); toast.success("Link do jogo copiado!"); }
      catch { toast.error("Não foi possível compartilhar o link neste navegador."); }
    }
  };
  return <>
    <div className="mt-1 flex items-center gap-2">
      <Button type="button" disabled={disabled} onClick={() => onPlay?.(event.id)} className="min-w-0 flex-1 bg-[#fccf1f] font-bold text-black hover:bg-[#e6bc1c]" data-testid={`play-special-btn-${event.id}`}><Play className="mr-2 h-4 w-4" />Jogar</Button>
      <Button type="button" variant="outline" disabled={busy} onClick={toggleLike} aria-label={liked ? `Descurtir ${event.title}` : `Curtir ${event.title}`} title={liked ? "Descurtir" : "Curtir"} aria-pressed={liked} className="shrink-0 border-white/20 px-3 text-pink-400"><Heart className={`h-5 w-5 ${liked ? "fill-current" : ""}`} /></Button>
      <Button type="button" variant="outline" onClick={share} aria-label={`Compartilhar ${event.title}`} title="Compartilhar" className="shrink-0 border-white/20 px-3"><Share2 className="h-5 w-5" /></Button>
    </div>
    <AuthModal open={showAuth} onClose={() => setShowAuth(false)} />
  </>;
}
